import React, { Component } from "react";
import { connect } from "react-redux";
import store from '../../store';
import { GetRequest } from "../common/helper";
import { apiUrl, color } from "../common/constants";
import { updatePathDtls } from "../../actions/search-actions";

class Showpath extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathlist: "",
    };
  }

  componentDidMount() {
    let that = this;
    let routeCode = this.props.routeCode;
    const pathapi = apiUrl.middlecities + '?RouteCode=' + routeCode;
    let cityarray = [];
    GetRequest(pathapi)
      .then(function (data) {
        if (data) {
          let routearray = data.APIGetActiveMiddleCitiesListResult;
          routearray.map(el => cityarray.push(el.CityName));
          store.dispatch(updatePathDtls(routeCode, routearray));
          that.setState({ pathlist: cityarray });
        }
      })
      .catch(function (error) { });
  }
  render() {
    if (this.state.pathlist) {
      let elemnt = [];
      let first = <span></span>//<span style={{ marginRight: '5px' }}>All Station:</span>
      elemnt.push(first);
      const rowLen = this.state.pathlist.length;
      let fromCity = this.props.search.searchParams.fromCity.split("|")[1];
      let toCity = this.props.search.searchParams.toCity.split("|")[1];
      this.state.pathlist.map((el, index) => {
        if (rowLen === index + 1) {
          el = el.toLowerCase() == fromCity.toLowerCase || el.toLowerCase() == toCity.toLowerCase() ? <span key={this.props.routeCode + index}><span style={{ color: color.green, fontWeight: '600' }}>{el}</span></span> : <span key={this.props.routeCode + index}><span>{el}</span></span>
          elemnt.push(el);

        } else {
          el = el.toLowerCase() == fromCity.toLowerCase() || el.toLowerCase() == toCity.toLowerCase() ? <span key={this.props.routeCode + index}><span style={{ color: color.green, fontWeight: '600' }}>{el}</span> -</span> : <span key={this.props.routeCode + index}> <span >{el} </span>- </span>
          elemnt.push(el);
        }
      })
      return (
        <div key={this.props.routeCode}>{elemnt}</div>
      );
    } else {
      // return <div key={this.props.routeCode}></div>;
      return (
        <div className="loading">
          <span></span>
          <span></span>
          <span></span>
        </div>
      )
    }
  }
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(Showpath);
